var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0308 0.95636C11.2331 0.95636 11.4354 1.00034 11.6202 1.08391L19.9024 4.59827C20.8701 5.00733 21.5914 5.96179 21.587 7.11418C21.565 11.4774 19.7705 19.4606 12.192 23.0893C11.4574 23.4412 10.6041 23.4412 9.86958 23.0893C2.29106 19.4606 0.4965 11.4774 0.474507 7.11418C0.470109 5.96179 1.19145 5.00733 2.15911 4.59827L10.4458 1.08391C10.6261 1.00034 10.8284 0.95636 11.0308 0.95636Z",
    fill: "#113348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85356 17.5993H9.57954C9.71312 17.5993 9.82153 17.7077 9.82153 17.8412V18.5672C9.82153 18.7008 9.71312 18.8092 9.57954 18.8092H8.85356C8.71998 18.8092 8.61157 18.7008 8.61157 18.5672V17.8412C8.61157 17.7077 8.71998 17.5993 8.85356 17.5993Z",
    fill: "#FF5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8208 5.74241C9.8208 5.60884 9.71239 5.50043 9.57881 5.50043H8.85283C8.71925 5.50043 8.61084 5.60884 8.61084 5.74241V16.1476C8.61084 16.2812 8.71925 16.3896 8.85283 16.3896H9.57881C9.71239 16.3896 9.8208 16.2812 9.8208 16.1476",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82092 11.5497C9.82092 10.8879 10.8342 10.9447 11.0309 10.9447C11.2276 10.9447 12.2408 10.9652 12.2408 11.5497C12.2408 11.9393 12.2408 14.2785 12.2408 18.5672C12.2408 18.7007 12.3492 18.8091 12.4828 18.8091H13.2088C13.3424 18.8091 13.4508 18.7007 13.4508 18.5672C13.4508 13.688 13.4508 11.0502 13.4508 10.6536C13.4508 10.0587 11.6145 9.73483 11.0309 9.73483C9.82092 9.73321 9.21594 9.93487 9.21594 10.3398",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazShield);
export default __webpack_public_path__ + "static/media/haz-shield.87c76dc85c948e91847343d62d89e14c.svg";
export { ForwardRef as ReactComponent };